export const ORDER_STATUSES = ["Draft", "Entered", "Confirmed", "In Production", "Shipped", "Delivered", "Invoiced", "Cancelled"];
export const ORDER_FLOW = ["Draft", "Entered", "Confirmed", "In Production", "Shipped", "Delivered", "Invoiced"];

export const ORDER_STATUS_COLORS = {
  Draft: "bg-gray-100 text-gray-700",
  Entered: "bg-blue-100 text-blue-700",
  Confirmed: "bg-indigo-100 text-indigo-700",
  "In Production": "bg-amber-100 text-amber-800",
  Shipped: "bg-cyan-100 text-cyan-700",
  Delivered: "bg-emerald-100 text-emerald-700",
  Invoiced: "bg-green-100 text-green-800",
  Cancelled: "bg-red-100 text-red-700",
};

export const ORDER_SOURCES = ["Manual", "Quote", "Reorder", "Excel", "AI"];
